// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__uEZFB","skeleton-animation":"styles_skeleton-animation__ifZV2"};